var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 13.746c3.27 0 5.977-2.713 5.977-5.976 0-3.27-2.713-5.977-5.983-5.977-3.264 0-5.97 2.707-5.97 5.977 0 3.263 2.712 5.976 5.976 5.976zm-2.068-3.422a.489.489 0 01-.34-.832l1.717-1.717L5.592 6.06a.479.479 0 01.34-.82c.14 0 .252.046.34.14l1.722 1.717 1.74-1.723a.45.45 0 01.334-.146.483.483 0 01.34.826L8.686 7.775l1.716 1.711c.094.1.141.211.141.346a.49.49 0 01-.486.492.503.503 0 01-.346-.146L7.994 8.46 6.29 10.178a.495.495 0 01-.357.146z",
    fill: "#fff"
  })));
}

export default __webpack_public_path__ + "static/media/close.0291acc2.svg";
export { SvgClose as ReactComponent };